import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../../../api/axios';
import {toast} from 'react-toastify';

type Props = {
  open: boolean;
  id?: number;
  steamUserName?: string;
  onClose: () => void;
  onDeleted: () => void;
};

const RemoveConnectedSteamAccount = ({open, id, steamUserName, onClose, onDeleted}: Props) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!id) return;

    setLoading(true);
    try {
      const response = await api.post(`/profile/steam-account/${id}/remove-steam-account`);

      if (response?.data?.message) {
        toast.success(t(response.data.message));
      }

      onDeleted();
      onClose();
    } catch (error: any) {
      console.error('Error deleting steam account:', error);
      const message = error?.response?.data || error.message;

      toast.error(t(message));
    } finally {
      setLoading(false);
    }
  };

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <div className="relative">
          <DialogTitle>{t('system.user.delete.title')}</DialogTitle>
          <IconButton
              aria-label="close"
              onClick={onClose}
              className="!absolute right-3 top-3 text-blue-600 hover:text-blue-800"
          >
            <CloseIcon/>
          </IconButton>
        </div>

        <DialogContent className="space-y-4">
          <div>{t('system.user.delete.text', {emaisl: steamUserName})}</div>
        </DialogContent>

        <DialogActions className="mr-4 mb-4">
          <Button onClick={onClose} className="text-gray-700 dark:text-gray-200">
            {t('system.user.delete.cancel')}
          </Button>
          <Button
              variant="contained"
              color="error"
              onClick={handleDelete}
              disabled={
                  loading ||
                  !id
              }
          >
            {t('system.user.delete.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default RemoveConnectedSteamAccount;